import type enCountryLocale from "i18n-iso-countries/langs/en.json";

export { AddressPurpose } from "@waterly/graphql-types";

export type CountryCodeKey = keyof typeof enCountryLocale.countries;

export type AddressFormValues = {
  label: string | null;
  recipientName: string | null;
  line1: string | null;
  line2: string | null;
  phone: string | null;
  city: string | null;
  region: string | null;
  postalCode: string | null;
  countryCode: CountryCodeKey;
  purpose: string;
};

export type AddressFieldName = keyof AddressFormValues;

export type AddressFieldConfig = {
  visible?: boolean;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
};

export type AddressFieldsConfig = Partial<Record<AddressFieldName, AddressFieldConfig>>;

// a system also has to supply the state, so it overrides region.required on top of this
export const LOCATION_FIELDS: AddressFieldsConfig = {
  label: { visible: false },
  recipientName: { visible: false },
  purpose: { visible: false },
  region: { helperText: "two-letter state/region code, e.g. CA, ON, TX" },
};
